import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, CalendarCheck, CalendarDays, FileText, Fingerprint } from 'lucide-react';

const mobileNavItems = [
  { label: 'Home', icon: LayoutDashboard, path: '/dashboard' },
  { label: 'Clock', icon: Fingerprint, path: '/dashboard/clock' },
  { label: 'Attend', icon: CalendarCheck, path: '/dashboard/attendance' },
  { label: 'Leave', icon: CalendarDays, path: '/dashboard/leave' },
  { label: 'Payslip', icon: FileText, path: '/dashboard/payroll' },
];

export default function MobileBottomNav() {
  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 safe-area-bottom"
      data-testid="mobile-bottom-nav"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex items-center justify-around h-14">
        {mobileNavItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/dashboard'}
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 w-full h-full transition-colors ${
                isActive
                  ? 'text-[#0D2850]'
                  : 'text-slate-400'
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            <span className="text-[10px] font-medium leading-none">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
